import { Injectable } from '@angular/core';

import { ClientConfig, ClientConfigProductName } from '@frontend/vanilla/core';

@ClientConfig({
    key: 'widgetVisibilityConfig',
    product: ClientConfigProductName.OZONE,
})
@Injectable({ providedIn: 'root' })
export class WidgetVisibilityConfig {
    enabled: boolean;
    markReadyFallback: number;
}
